import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function Play(props: IconProps) {
  return (
    <IconSvg {...props}>
      <path d="M15.654 12.569a.424.424 0 00-.654.355v10.152a.426.426 0 00.424.424.417.417 0 00.23-.069l7.615-5.076a.424.424 0 000-.71l-7.615-5.076zM34 18c0 8.837-7.163 16-16 16S2 26.837 2 18 9.163 2 18 2a16 16 0 0116 16zm-1.5 0c0-8.008-6.492-14.5-14.5-14.5S3.5 9.992 3.5 18 9.992 32.5 18 32.5c8.004-.009 14.491-6.496 14.5-14.5z"></path>
    </IconSvg>
  );
}
